import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import TabSueldos from './Componentes/TabSueldos';
import TabHistorico from './Componentes/TabHistorico';
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import {useAuth} from "../Auth/State/AuthContext";
import {ACCESO_HISTORICO_SUELDOS} from "../Contantes/Constantes";
const DrawerDiv = styled("div")(({ theme }) => ({
    background: "#ffffff",
    marginTop: "-24px",
    width: "102.5%",
    marginLeft: "-24px",
}));
const Sueldos = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("lg"));
    const {hasRole} = useAuth();

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setTabValue(index);
    };

    return (
        <Box>
            <DrawerDiv sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                sx={{
                    borderBottom: '1px solid #ccc',
                    '& .MuiTab-root': { padding: '16px 0' },
                    '& .MuiTabs-indicator': { height: 2 },
                }}
            >
                <Tab sx={{
                    marginTop: matches ? "25px" : "10px",
                    paddingBottom: "17.5px",
                }} label="Sueldos" />
            {hasRole(ACCESO_HISTORICO_SUELDOS) && (
                <Tab
                    sx={{
                        marginTop: matches ? "25px" : "10px",
                        paddingBottom: "17.5px",
                    }}
                    label="Histórico"
                />
            )}
            </Tabs>
            </DrawerDiv>

            <SwipeableViews index={tabValue} onChangeIndex={handleChangeIndex}>
                <Box sx={{ p: 0 }}>{tabValue === 0 && <TabSueldos />}</Box>
                <Box sx={{p: 0}}>{tabValue === 1 && <TabHistorico/>}</Box>
            </SwipeableViews>
        </Box>

    );
};

export default Sueldos;
